import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import LoginView from '../views/LoginView.vue'
import HomeView from '../views/HomeView.vue'
import LeaveView from '../views/LeaveView.vue'
import ExpensesView from '../views/ExpensesView.vue'

var VueCookie = require('vue-cookie');

Vue.use(VueCookie)
Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView
  },
  {
    path: '/',
    name: 'diensten',
    beforeEnter: guardMyroute,
    component: HomeView
  },
  {
    path: '/leave',
    name: 'verlof',
    beforeEnter: guardMyroute,
    component: LeaveView
  },
  {
    path: '/expenses',
    name: 'onkosten',
    beforeEnter: guardMyroute,
    component: ExpensesView
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

function guardMyroute(to, from, next)
{
  axios
    .post(process.env.VUE_APP_API_URL + '/auth/app', { token: VueCookie.get('token') })
    .then(response => {
      if(response.data.status === '2') {
        Vue.prototype.$globalData.appData = response.data.appData
        next();
      }
      else {
        next('/login');
      }
    })
    .catch(error => {
      console.log(error)
    })
}

export default router
